








































import { Component, Vue, Prop } from 'nuxt-property-decorator'
import { TVideoType } from '~/assets/interfaces/video'

@Component
export default class ComponentVideo extends Vue {
  @Prop({ type: String }) readonly item!: string
  @Prop({ type: String, default: 'rutube' }) readonly type!: TVideoType
  @Prop({ type: String, default: '' }) readonly poster!: string

  private hasError = false
  private hls: any = null

  private get isFile(): boolean {
    return this.type === 'video' || this.type === 'hls'
  }

  private mounted() {
    if (this.type === 'hls') {
      this.playStream()
    }
  }

  private beforeDestroy() {
    this.destroyStream()
  }

  /**
   * Поток HLS (в таком виде отдаёт видео Wildberries) браузеры сами играть не
   * умеют — кроме Safari и вебвью iOS. Для остальных подключаем hls.js, и
   * грузим его отдельным чанком только когда поток действительно встретился.
   */
  private async playStream() {
    const player = this.$refs.player as HTMLVideoElement

    if (!player) {
      return
    }

    if (player.canPlayType('application/vnd.apple.mpegurl')) {
      player.src = this.item
      return
    }

    try {
      const module = await import('hls.js')
      const Hls = module.default

      if (!Hls.isSupported()) {
        this.hasError = true
        return
      }

      this.hls = new Hls()
      this.hls.loadSource(this.item)
      this.hls.attachMedia(player)
      this.hls.on(Hls.Events.ERROR, (_event: string, data: any) => {
        if (data && data.fatal) {
          this.hasError = true
          this.destroyStream()
        }
      })
    } catch (e) {
      this.hasError = true
    }
  }

  private destroyStream() {
    if (this.hls) {
      this.hls.destroy()
      this.hls = null
    }
  }
}
